import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Api from '../../../api';
import styles from './CourseReturnPage.module.scss';

type LocationState = { lmsCourseId?: number };

const CourseReturnPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const courseId = location.state?.lmsCourseId;
  const [message, setMessage] = React.useState<string>('Updating your course progress...');

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await Api.updateToken();
        if (courseId) {
          await Api.getCourseProgress(courseId);
        } else {
          await Api.getCourses();
        }
        if (!cancelled) {
          setMessage('Progress updated.');
        }
      } catch (e) {
        if (!cancelled) setMessage('Could not verify latest progress, please check your courses list.');
      }
    })();
    return () => { cancelled = true; };
  }, [courseId]);

  return (
    <div className={styles.page}>
      <div className={styles.title}>Course complete</div>
      <div className={styles.message}>{message}</div>
      <button type="button" className={styles.backButton} onClick={() => history.push({ pathname: 'coursesHome' })}>
        Back to Courses
      </button>
    </div>
  );
};

export default CourseReturnPage;
